import DailyMacroBrief from "@/components/cot/DailyMacroBrief";
import USDNewsBanner from "@/components/cot/USDNewsBanner";

// Unified Macro Desk: Daily Macro Brief (cross-market AI read) + Macro Bias
// (per-currency news bias) inside a single bordered card with a divider.
export default function MacroDesk() {
  return (
    <div className="border border-amber-500/30" data-testid="macro-desk">
      <DailyMacroBrief embedded />
      <div className="border-t border-zinc-800" />
      <USDNewsBanner embedded />
    </div>
  );
}
